export interface ChatMessage {
    role: 'user' | 'assistant';
    content: string;
    isStreaming?: boolean;
    id?: string;
    rating?: 0 | 1;
    metadata?: Record<string, any>;
    created_at?: string;
}

export interface ChatResponse {
    conversation_id?: string;
    message: string;
    created_at?: number;
}

export interface StreamChunk {
    type: 'chunk' | 'content' | 'metadata' | 'error' | 'done';
    content?: string;
    conversation_id?: string;
    created_at?: number;
    error?: string;
    metadata?: {
        context_used?: boolean;
        ai_message_id?: string;
        user_message_id?: string;
    };
}

export interface ChatRequest {
    message: string;
    conversation_id?: string;
    prompt_name?: string;
}

export interface ChatConversation {
    id?: string;
    title: string;
    prompt_name?: string;
    created_at?: number;
    updated_at?: number;
    message_count?: number;
    isPending?: boolean;
}

export enum SSEEventType {
    CONNECTED = 'connected',
    TITLE_UPDATED = 'title_updated',
    ERROR = 'error',
    TIMEOUT = 'timeout',
}

export interface SSEEvent {
    type: SSEEventType;
    data?: {
        title?: string;
        error?: string;
        message?: string;
    };
    conversation_id?: string;
}
